// İSG uzmanı portalı — yönetim paneli erişim kapısı (route guard UX).
//
// Asıl yetki backend'dedir ([ModuleAction("admin-*")]); bu kapı yalnız UX'tir:
// backend sondasının (useAdminAccess) sonucuna göre paneli, 403 sayfasını veya
// "servis kullanılamıyor" durumunu gösterir. `granted` → doğrudan `Outlet` (S33 Slice 6
// owner kararı — bu kapı ARTIK `AdminShell`'i KENDİSİ render ETMEZ; `AdminShell` router.tsx'te
// yalnız liste sekmelerini saran AYRI, yol'suz bir iç-içe layout rotasıdır. Firma/Şube/Rol
// detay sayfaları AdminShell'in Outlet'i DIŞINDA, bu kapının DOĞRUDAN çocuklarıdır — kendi
// Breadcrumb+PageHeader'larını taşırlar, kabuğun ikinci bir başlık bloğu üretmesi önlenir.
// Yetki sondası (bu kapı) HER İKİ alt ağaç için de AYNI kalır — URL'ler değişmedi.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { ShieldAlert, ShieldX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useAdminAccess } from '../../lib/adminAccess';

export function AdminGate() {
  const { t } = useTranslation();
  const access = useAdminAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('admin.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ShieldX className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('admin.forbidden.title')}</h1>
              <p className="text-sm text-muted">{t('admin.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('admin.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <ShieldAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">{t('admin.unavailable.title')}</h1>
              <p className="text-sm text-muted">{t('admin.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('admin.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
